import { Model } from '@vuex-orm/core'
import PrivateChatPost from '@/store/models/PrivateChatPost'

export default class PrivateChat extends Model {
  static entity = 'privateChats'

  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(null),
      userId: this.attr(null),
      unreadCount: this.number(0),
      recentPostAt: this.attr(null),
      privateChatPosts: this.hasMany(PrivateChatPost, 'privateChatId'),
      meta: this.attr(null)
    }
  }
}
